import { CommonDataService } from 'src/app/core/services/common-data.service';
import { CarSequenceService } from './../../services/car-sequence.service';
import { deepCopy, isNullOrEmpty, onDropdownKeydown } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, Injector, OnInit } from '@angular/core';
import { BookingService } from '../../services/booking.service';
import { DropdownOptionsService } from './../../../../core/services/dropdown-options.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { FacilityService } from 'src/app/core/services/facility.service';
import { LaasOption } from 'src/app/core/models/laas-option';

@Component({
  selector: 'laas-booking-header-edit',
  templateUrl: './booking-header-edit.component.html',
  styleUrls: ['./booking-header-edit.component.scss']
})
export class BookingHeaderEditComponent extends SessionBaseComponent implements OnInit {

  bookingModel: any;
  updateParams: any;
  forwarderOptions: any[];
  letterHeadOptions: any[];
  expressTermOptions:any[];
  billCorpOptions: any[];
  carTypeOptions: any[];
  carSeqOptions: any[];
  carrierPaymentTypeOptions: any[];
  carrierPaymentByOptions: LaasOption[];
  deliveryTypeOptions: any[];
  deliverSubTypeOptions: any[];
  bookingTypeOptions: any[];
  chargeOptions: any[];
  pickupLocationOptions: any[];
  incoTermOptions: any[];
  payTypeOptions: any[];
  accountIdOptions: any[];
  rfqAreaOptions: any[];
  bookingStatusOptions: any[];
  facilityOptions: any[];
  isEditTotalCaseCnt: boolean = false;
  isEditTotalGrosswgt: boolean = false;
  isEditTotalVolumeWeight: boolean = false;
  isEditTotalPalletCnt: boolean = true;
  isEditTotalPalletWeight: boolean = true;
  isEditBookingFormExpressTerm: boolean = false;
  isEditCarType: boolean = false;
  isEditShipTerm = false;
  countryOptions: any[];
  cityOptions: any[];
  fromCityOptions: any[];
  toAreaOptions: any[];
  toAirportOptions: any[];
  shipMethodOptions: any[];
  originShipTerm: any = '';

  showCityOptions:any;
  showAreaOptions:any;

  protected readonly onDropdownKeydown = onDropdownKeydown;

  constructor(
    injector: Injector,
    private dropdownOptionService: DropdownOptionsService,
    private commonDataService: CommonDataService,
    private bookingService: BookingService,
    private carSeqService: CarSequenceService,
    private facilityService: FacilityService,
    private datePipe: DatePipe
  ) {
    super(injector);

    this.forwarderOptions = [];
    this.letterHeadOptions = [];
    this.expressTermOptions = []
    this.billCorpOptions = [];
    this.carTypeOptions = [];
    this.carSeqOptions = [];
    this.carrierPaymentTypeOptions = [];
    this.carrierPaymentByOptions = [];
    this.deliveryTypeOptions = [];
    this.deliverSubTypeOptions = [];
    this.bookingTypeOptions = [];
    this.chargeOptions = [];
    this.pickupLocationOptions = [];
    this.incoTermOptions = [];
    this.payTypeOptions = [];
    this.accountIdOptions = [];
    this.rfqAreaOptions = [];
    this.bookingStatusOptions = [];
    this.facilityOptions = [];
    this.updateParams = {};
    this.countryOptions = [];
    this.cityOptions = [];
    this.fromCityOptions = [];
    this.toAreaOptions = [];
    this.toAirportOptions = [];
    this.shipMethodOptions = [];

    this.showCityOptions = false;
    this.showAreaOptions = false;

    this.bookingModel = this.routeStateService.getCurrent().data;
    this.originShipTerm = deepCopy(this.bookingModel.shipTerm);
    this.bookingModel.tmpCarSeq = this.bookingModel.carSeq?.slice(-4);
    this.bookingModel.incoTerm = "";
    this.bookingModel.tmpAssignDate = this.datePipe.transform(this.bookingModel.assignDate, 'yyyy/MM/dd', this.laasSetting.facilityTimeZone);
    this.bookingModel.flyDate1TimeZone = this.datePipe.transform(this.bookingModel.flyDate1, 'yyyy/MM/dd', this.laasSetting.facilityTimeZone);
    this.bookingModel.flyDate2TimeZone = this.datePipe.transform(this.bookingModel.flyDate2, 'yyyy/MM/dd', this.laasSetting.facilityTimeZone);
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.isEditTotalCaseCnt = this.permissionCodes.includes(PermissionConstants.EditBookingFormUpdatedTotalCaseCnt);
    this.isEditTotalGrosswgt = this.permissionCodes.includes(PermissionConstants.EditBookingFormUpdatedTotalGrosswgt);
    this.isEditTotalVolumeWeight = this.permissionCodes.includes(PermissionConstants.EditBookingFormUpdatedTotalVolumeWeight);
    this.isEditShipTerm = this.bookingModel?.bookingStatus == '0' && this.bookingModel?.deliveryType.toUpperCase() !== "LOCAL";

    // TODO 下面這邊要去判斷 isEditCarType 去看他能否修改
    this.bookingService.checkIsEditCarType(this.bookingModel.bookingNo)
      .subscribe({
        next: result => {
          this.isEditCarType = result;
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        }
      });

    this.bookingService.getBookingDetail(this.laasSetting.facility, this.bookingModel.bookingNo)
      .subscribe({
        next: result => {
          this.bookingModel.details = result.searchBookingDetailList;
          this.isEditBookingFormExpressTerm = this.permissionCodes.includes(PermissionConstants.EditBookingFormExpressTerm)
              && 'Y' !== this.bookingModel.isFeeCaculation;

          this.updateCarSeqOptions(this.bookingModel);
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        }
      });

    this.dropdownOptionService.getForwarderOptions(this.bookingModel.facility)
      .subscribe({
        next: (options: any[]) => {
          this.forwarderOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.facilityService.getBillObjectOptions(this.bookingModel.facility, this.bookingModel.carrierPaymentType).subscribe({
      next: result => {
        this.carrierPaymentByOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.dropdownOptionService.getLetterOrgOptions(this.bookingModel.facility)
      .subscribe({
        next: (options: any[]) => {
          this.letterHeadOptions = options.map(x => ({ label: x.legalEntityOUName, value: x.legalEntityOUCode, src: x }));
          console.log('this.letterHeadOptions', this.letterHeadOptions);

          this.billCorpOptions = options.filter(x => !isNullOrEmpty(x.billOUCode)).map(x => ({ label: x.billOUName, value: x.billOUCode }));
          console.log('this.bookingModel.facility', this.bookingModel.facility);
        }
      });

    this.dropdownOptionService.findFacilityOptionsByOptionType("ExpressTerm").subscribe({
      next: (options: any[]) => {
        this.expressTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionService.getPickupLocationOptions(this.bookingModel.facility)
      .subscribe({
        next: (options: any[]) => {
          this.pickupLocationOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionService.getCarTypeOptions()
      .subscribe({
        next: (options: any[]) => {
          this.carTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionService.getCarrierPaymentTypeOptions()
      .subscribe({
        next: (options: any[]) => {
          this.carrierPaymentTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionService.getDeliveryTypeOptions(false)
      .subscribe({
        next: (options: any[]) => {
          this.deliveryTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionService.getDeliverySubTypeOptions('O')
      .subscribe({
        next: (options: any[]) => {
          this.deliverSubTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionService.getBookingTypeOptions()
      .subscribe({
        next: (options: any[]) => {
          this.bookingTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionService.getChargeOptions()
      .subscribe({
        next: (options: any[]) => {
          this.chargeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShipTerm').subscribe({
      next: result => {
        this.incoTermOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.dropdownOptionService.getPayTypeOptions()
      .subscribe({
        next: (options: any[]) => {
          this.payTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionService.getAccountIdOptions(this.bookingModel.facility, this.bookingModel.bookingForwarder)
      .subscribe({
        next: (options: any[]) => {
          this.accountIdOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionService.getBookingStatusOptions()
      .subscribe({
        next: (options: any[]) => {
          this.bookingStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
    this.dropdownOptionService.getFacilityOptions()
      .subscribe({
        next: (options: any[]) => {
          this.facilityOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionService.getCountryOptions()
      .subscribe({
        next: (options: any[]) => {
          this.countryOptions = options.map(x => ({ label: x.countryName, value: x.countryCode }));
      }
    });

    this.dropdownOptionService.getAllCityOptions()
    .subscribe({
      next: (options: any[]) => {
        this.fromCityOptions = options.map(x => ({ label: x.name, value: x.seqNo.toString() }));
        this.cityOptions = options.filter(x => x.country == this.bookingModel.toCountry).map(x => ({ label: x.name, value: x.seqNo.toString() }));
      }
    });

    this.dropdownOptionService.getAllAreaOptions()
    .subscribe({
      next: (options: any[]) => {
        this.toAreaOptions = options.filter(x => x.citySeqNo == Number(this.bookingModel.toCity) ).map(x => ({ label: x.rfqAreaName, value: x.rfqAreaCode }));
      }
    });

    this.dropdownOptionService.getAirPortOptions(this.bookingModel.toCity)
      .subscribe({
        next: (options: any[]) => {
          this.toAirportOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
    });

    this.facilityService.getShipMethodOptions().subscribe({
      next: (options: any[]) => {
        this.shipMethodOptions = options.map(x => ({ label: `${x.optionCode}-${x.optionDesc}`, value: x.optionCode }));
      }
    });
  }

  saveBtnClick(event: any): void {

    let location = '';
    if (this.originShipTerm && this.originShipTerm.length > 3) {
      const firstCode = this.originShipTerm.substr(0, 1);
      const thirdCode = this.originShipTerm.substr(3, 1);
      let afterThirdCode = this.originShipTerm.substr(3);
      if (firstCode === '_') {
        location += this.originShipTerm;
      } else if (thirdCode === '-' || thirdCode === '_') {
        location += afterThirdCode;
      } else {
        afterThirdCode = afterThirdCode.indexOf(')') > -1 ? afterThirdCode.substr(afterThirdCode.indexOf(')') + 1) : afterThirdCode;
        if (afterThirdCode.indexOf('-') > -1) {
          location += afterThirdCode.substr(afterThirdCode.indexOf('-'));
        } else if (afterThirdCode.indexOf('_') > -1) {
          location += afterThirdCode.substr(afterThirdCode.indexOf('_'));
        }
      }
    }

    if (this.bookingModel.shipTerm !== this.originShipTerm) {
      this.bookingModel.shipTerm += location;
    }
    this.bookingModel.flyDate1 = isNullOrEmpty(this.bookingModel.flyDate1TimeZone) ? null : new Date(this.bookingModel.flyDate1TimeZone).toISOString();
    this.bookingModel.flyDate2 = isNullOrEmpty(this.bookingModel.flyDate2TimeZone) ? null : new Date(this.bookingModel.flyDate2TimeZone).toISOString();
    this.bookingModel.assignDate = isNullOrEmpty(this.bookingModel.tmpAssignDate) ? null : new Date(this.bookingModel.tmpAssignDate).toISOString();
    this.bookingModel.carSeq = this.bookingModel.carTrip.substring(0, 12);
    this.bookingModel.updateUser = this.userProfile.userName;
    this.bookingModel.updateDt = new Date().toISOString();

    if (!isNullOrEmpty(this.bookingModel.expressBill)){
      if(this.bookingModel.expressBill.length > 50){
        this.toastService.error(this.translateService.instant('ReceiptFormHeaderDetailsEdit.HAWBNoWordCountExceeds'));
        return;
      }
    }

    this.bookingService.getDoList(this.bookingModel.bookingNo).subscribe({
      next: doList => {
        this.updateParams.facility = this.bookingModel.facility;
        this.updateParams.bookingNo = this.bookingModel.bookingNo;
        this.updateParams.bookingForwarder = this.bookingModel.bookingForwarder;
        this.updateParams.deliveryOrder = doList;
        this.updateParams.payType = this.bookingModel.payType;
        if (this.bookingModel.payType === 'S') {
          this.updateParams.shipperAccountId = this.bookingModel.accountId;
        } else {
          this.updateParams.billingAccountId = this.bookingModel.accountId;
        }
        this.updateParams.recipientPostalCode = this.bookingModel.toArea;
        this.updateParams.shipTerm = this.bookingModel.shipTerm;
        this.updateParams.recipientCity = this.bookingModel.toCity;
        this.updateParams.recipientCountryCode = this.bookingModel.toCountry;
        this.updateParams.totalCaseCnt = this.bookingModel.updatedTotalCaseCnt;
        this.updateParams.totalGrosswgt = this.bookingModel.updatedTotalGrosswgt;
        this.updateParams.coOrgId = this.bookingModel.coOrgId;

        this.bookingService.saveDHLInfo(this.updateParams).subscribe();
      }
    });

    this.bookingService.updateBooking(this.bookingModel)
      .subscribe({
        next: (result: any) => {
          this.translateService.get('Common.Message.SuccessSave')
            .subscribe({
              next: msg => {
                this.toastService.success(msg);
                this.routeStateService.loadPrevious();
              }
            });
        },
        error: (err: any) => {
          if (err.error.errorMsg) {
            this.toastErrorMessage(err.error.errorMsg);
            return;
          }
          this.toastErrorMessage(err.error);
        }
      });
  }

  letterOrgIdDDLChange(event: any): void {
    const option = this.letterHeadOptions.find(x => x.value === event.value);
    this.bookingModel.billCorp = option.src.billOUCode;
  }

  /**
   * AssignDate select event.
   *
   * @param event p-calendar select event
   * @param booking Booking info
   */
  tmpAssignDateSelect(event: any, booking: any): void {
    booking.carSeq = null;
    this.updateCarTrip(booking);
    this.updateCarSeqOptions(booking);
  }

  tmpCarSeqDDLChange(event: any, booking: any): void {
    this.updateCarTrip(booking);
  }

  /**
   * Car type selector change event.
   *
   * @param event laas-car-type-selector value change event.
   * @param booking Booking info
   */
  carTypeSelectorChange(event: any, booking: any): void {
    booking.carSeq = null;
    booking.tmpAssignDate = '';
    this.updateCarTrip(booking);
    this.updateCarSeqOptions(booking);
  }

  isDisabledUpdate(): boolean{
    return ["2", "5"].includes(this.bookingModel?.bookingStatus);
  }

  /**
   * Check whether to disabled widget or not.
   *
   * @param booking Booking detail
   * @param field Target property
   */
  isDisableWidget(booking: any, field: string): boolean {
    switch (field) {
      case 'carSeq':
      case 'assignDate':
        return isNullOrEmpty(booking.bookingForwarder) ||
          booking.bookingForwarder?.startsWith('00000') ||
          isNullOrEmpty(booking.carType) === false;
      case 'carType':
        return isNullOrEmpty(booking.bookingForwarder) ||
          booking.bookingForwarder?.startsWith('00000');
      default:
        return false;
    }
  }

  private updateCarTrip(booking: any): void {
    const carTripParams = {
      facility: booking.facility,
      deliveryCategory: booking.deliveryCategory,
      etd: booking.details[0].etd,
      plannedDeliveryTime: isNullOrEmpty(booking.tmpAssignDate) ? null : new Date(booking.tmpAssignDate).toISOString(),
      assignmentDistrictId: booking.assignmentDistrictId,
      hvsRemark: booking.details[0].hvsRemark,
      assignCar: booking.carType,
      collection: booking.bookingForwarder?.startsWith('00000') ? booking.bookingForwarder : null,
      forwarderId: booking.bookingForwarder,
      consigneeKey: booking.consigneeKey,
      carSeq: booking.tmpCarSeq,
      storer: booking.details[0].storer
    };
    this.carSeqService.getCarTrip(carTripParams)
      .subscribe({
        next: carTrip => {
          booking.carTrip = carTrip;
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  private updateCarSeqOptions(booking: any): void {
    booking.carSeqOptions = [];
    const carTripParams = {
      facility: booking.facility,
      deliveryCategory: booking.deliveryCategory,
      etd: booking.details[0].etd,
      plannedDeliveryTime: isNullOrEmpty(booking.tmpAssignDate) ? null : new Date(booking.tmpAssignDate).toISOString(),
      assignmentDistrictId: booking.assignmentDistrictId,
      hvsRemark: booking.details[0].hvsRemark
    };
    this.carSeqService.getCarSeqOptions(carTripParams)
      .subscribe({
        next: (options: any[]) => {
          this.carSeqOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  changeCityOptions(): void {

    this.bookingModel.toArea = "";
    this.bookingModel.toCity = "";
    this.bookingModel.toAirport = "";

    this.dropdownOptionService.getAllCityOptions()
    .subscribe({
      next: (options: any[]) => {
        this.cityOptions = options.filter(x => x.country == this.bookingModel.toCountry).map(x => ({ label: x.name, value: x.seqNo.toString() }));
      }
    });

    this.toAreaOptions = [];
    this.toAirportOptions = [];
  }

  changeAreaOptions(): void {
    console.log("changeAreaOptions:",this.bookingModel.toCity + "," +this.bookingModel.toArea + ", " +this.bookingModel.toAirport);

    this.bookingModel.toArea = "";
    this.bookingModel.toAirport = "";

    this.dropdownOptionService.getAllAreaOptions()
    .subscribe({
      next: (options: any[]) => {
        this.toAreaOptions = options.filter(x => x.citySeqNo == Number(this.bookingModel.toCity) ).map(x => ({ label: x.rfqAreaName, value: x.rfqAreaCode }));
      }
    });

    this.dropdownOptionService.getAirPortOptions(this.bookingModel.toCity)
      .subscribe({
      next: (options: any[]) => {
        this.toAirportOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });
  }

  changeCharge(): void {
    if (this.bookingModel.deliveryType == "EXPORT") {
      if (this.bookingModel.shipTerm == "FCA" || this.bookingModel.shipTerm =="FOB") {
        this.bookingModel.airfreightCharge = "2";
        this.bookingModel.otherCharge = "1";
      }
      else if (this.bookingModel.shipTerm == "EXW") {
        this.bookingModel.airfreightCharge = "2";
        this.bookingModel.otherCharge = "2";
      }
      else {
        this.bookingModel.airfreightCharge = "1";
        this.bookingModel.otherCharge = "1";
      }
    }
  }

  changeCarrierPaymentBy(): void {
    this.bookingModel.carrierPaymentBy = '';

    this.facilityService.getBillObjectOptions(this.bookingModel.facility, this.bookingModel.carrierPaymentType).subscribe({
      next: result => {
        this.carrierPaymentByOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });
  }

  isFeeCalculation(): boolean {
    return 'Y' === this.bookingModel?.isFeeCaculation;
  }

  goToLastPage(): void {
    this.routeStateService.loadPrevious();
  }
}
